import React from 'react';
import { Card, CardHeader, CardBody, Col, Row,  } from 'reactstrap';
import '../App.css';
import DeleteIcon from '@material-ui/icons/Delete';

class CurveInfo extends React.Component {
    constructor(props){
      super(props);
  
      this.state = {
        curves: props.data,
        editClick: props.editHandler,
      };
    } 

    BtnClick = (event,index) =>{
        this.props.editHandler(index);
        console.log('edit index =', index);
    }

    updateTwist = () =>{

      
    }
  
    render() {

      let info = [];

      let bckgrnd1 = {
        backgroundColor: 'lightgrey',
      }

      let bckgrnd2 = {
        backgroundColor: 'white',
      }

      let btn = {
        width: '15px',
        height: '15px',
        display: 'block',
      }



      /*
            <Col className='curveDataBtnRow'>
                <button onClick={(event) => this.BtnClick(event,index)} className='curveDataBtn'>
                <DeleteIcon style={btn}/>
                <div className='curveDataBtnFont'>Edit</div>
                </button>
            </Col>
      */


        {this.props.data.map((curve,index) => {

        let bg_color = null;
        if(index % 2 === 0){
            bg_color = bckgrnd1;
        }else{
            bg_color = bckgrnd2;
        }

         let i = (
          <Row style={bg_color} className='cardRow' key={curve.key}>
            
            <Col className='curveData'>{curve.name}</Col>
            <Col className='curveData'>{curve.draft.toFixed(1)}</Col>
            <Col className='curveData'>{curve.camber.toFixed(3)}</Col>
            <Col className='curveData'>{curve.twist.toFixed(1)}</Col>
            <Col className='curveData'>{curve.EntryAngle.toFixed(0)}</Col>
            <Col className='curveData'>{curve.ExitAngle.toFixed(0)}</Col>
            <Col className='curveData'>{curve.frontPercent ? curve.frontPercent.toFixed(1) : " "}</Col>
            <Col className='curveData'>{curve.backPercent ? curve.backPercent.toFixed(1) : " "}</Col>
          </Row>
          );
          info.push(i);
          })  
        };
  


      let header = (
        <Row className='cardsubheading'>
        
        <Col className='curveHeading'>Stripe</Col>
        <Col className='curveHeading'>Draft</Col>
        <Col className='curveHeading'>Camber</Col>
        <Col className='curveHeading'>Twist</Col>
        <Col className='curveHeading'>Entry</Col>
        <Col className='curveHeading'>Exit</Col>
        <Col className='curveHeading'>Front%</Col>
        <Col className='curveHeading'>Back%</Col>
      </Row>
      );
  
    
  
      return (
            <Card className='card'style={{boxShadow:'rgba(0, 0, 0, 0.2) 0px 8px 12px 0px, rgba(0, 0, 0, 0.2) 0px 6px 12px 0px'}}>
                <CardHeader className='cardheadr' >Curve Data</CardHeader>
                <CardBody className='cardbody'>
                    {header}
                    {info}
                </CardBody>
            </Card>    
      );
    }
  }
  
  export default CurveInfo;